import { render, staticRenderFns } from "./commissioniCommerciali.vue?vue&type=template&id=e64abcca&"
import script from "./commissioniCommerciali.vue.ts?vue&type=script&lang=ts&"
export * from "./commissioniCommerciali.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports